export default "__VITE_ASSET__CUYEZ_I5__"